<mat-drawer-container class="container-drawer">
  <mat-drawer mode="side" [opened]="sideBarOpen">
    <app-sidenav
      [currentUser]="currentUser"
      [selectedFileUrl]="selectedFileUrl"
      (toggleSidenavEvent)="onToggleSidenav($event)"
      (toggleSidebarForMe)="sideNavToggler()"></app-sidenav>
  </mat-drawer>
  <mat-drawer-content
    class="content-drawer"
    [ngClass]="{
      'sidenav-opened':
        isSideNavCollapsed && screenWidth > 768 && !isSmallScreen,
      'small-screen': isSmallScreen,
    }">
    <app-toolbar
      [collapsed]="isSideNavCollapsed"
      [screenWidth]="screenWidth"
      [isLoggedIn]="true"
      [userLanguage]="currentUser?.preferredLanguage"
      [groupeEtablissement]="currentUser?.groupEtablissement"
      [selectedEtablissement]="selectedEtablissement"
      (toggleSidebarForMe)="sideNavToggler()"></app-toolbar>

    <div class="body" [ngClass]="getBodyClass()">
      <app-content></app-content>
    </div>
    @if (isSmallScreen && sideBarOpen) {
      <div class="background"></div>
    }
  </mat-drawer-content>
</mat-drawer-container>
